module.exports = __webpack_public_path__ + "static/img/p-s4-6.8d802a83.png";